 
export const BillboardViewType = Object.freeze({
    Calendar: 'month',
    List: 'list',
});
